import posthog from 'posthog-js';

/** Call after loadUser() resolves, so sessions are tied to a real person. */
export function phIdentify({ email, role, companyId }) {
  if (!email) return;
  posthog.identify(email, {
    email,
    role: role ? String(role).toLowerCase() : null,
    company_id: companyId ?? null,
  });
}

/** Call in signOut, before clearing session state. */
export function phReset() {
  posthog.reset();
}

export function phInviteSent({ role }) {
  posthog.capture('portal_invite_sent', { role });
}

export function phInviteFailed({ role, reason }) {
  posthog.capture('portal_invite_failed', { role, reason: reason ?? 'unknown' });
}

export function phSeatAssigned({ isSelf }) {
  posthog.capture('portal_seat_assigned', { is_self: !!isSelf });
}

export function phSeatAssignFailed({ isSelf, reason }) {
  posthog.capture('portal_seat_assign_failed', { is_self: !!isSelf, reason: reason ?? 'unknown' });
}

export function phSharePointConnected({ siteName }) {
  posthog.capture('portal_sharepoint_connected', { site_name: siteName ?? null });
}

export function phSharePointConnectFailed({ reason }) {
  posthog.capture('portal_sharepoint_connect_failed', { reason: reason ?? 'unknown' });
}

/** result.reason from POST /auth/magic-link/request: 'no_portal_access' | 'rate_limited' */
export function phMagicLinkRequestFailed({ reason }) {
  posthog.capture('portal_magic_link_request_failed', { reason });
}

/** Fired when clicking "Confirm sign-in" on VerifyPage comes back invalid/expired. */
export function phMagicLinkVerifyFailed({ reason }) {
  posthog.capture('portal_magic_link_verify_failed', { reason: reason ?? 'unknown' });
}
